import { useStepNavigation } from "app/hooks/grid/useStepNavigation";

import {
  NOTIFICATION_RULE_STEP_IDS,
  RULES_DELIVERY_METHOD_HELP_CONTENT,
  RULES_FILTERS_HELP_CONTENT,
} from "../consts";

/** Help copy for the wizard step named in the `step` search param. */
export function useNotificationRuleHelpContent() {
  const { currentStep } = useStepNavigation({
    stepIds: NOTIFICATION_RULE_STEP_IDS,
  });

  return currentStep === 0
    ? RULES_FILTERS_HELP_CONTENT
    : RULES_DELIVERY_METHOD_HELP_CONTENT;
}
